import { motion } from "framer-motion";

// Designed thin section divider with a centered roof-chevron accent.
export default function LineDivider() {
  return (
    <div data-testid="hero-divider" className="bg-white">
      <div className="mx-auto max-w-6xl px-5 md:px-10 py-6 md:py-8">
        <motion.div
          initial={{ opacity: 0, scaleX: 0.6 }}
          whileInView={{ opacity: 1, scaleX: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
          className="flex items-center gap-4 origin-center"
        >
          <span className="h-px flex-1 bg-gradient-to-r from-transparent via-slate-200 to-[#38A8CE]/40" />
          <span className="relative flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-gradient-to-br from-[#38A8CE] to-[#AECE2F] shadow-md">
            <svg viewBox="0 0 24 14" className="h-3.5 w-6 text-white" fill="none" aria-hidden="true">
              <path d="M2 12 12 3l10 9" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </span>
          <span className="h-px flex-1 bg-gradient-to-l from-transparent via-slate-200 to-[#AECE2F]/50" />
        </motion.div>
      </div>
    </div>
  );
}
